// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.GetRenterRentDetailsByInviteTokenHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetRentDetailsFromInviteRequestDto, GetRentDetailsFromInviteResponseDto } from '../..';

export const GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_Path =
  '/api/web/v1/getRentDetailsFromInvite';

/**
 * Get rent details from encrypted invite token
 */
export const GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite = (
  postData: GetRentDetailsFromInviteRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetRentDetailsFromInviteRequestDto, GetRentDetailsFromInviteResponseDto>(
    {
      endpoint: GetRenterRentDetailsByInviteTokenHandler_getRentDetailsFromInvite_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
